// collectionMetadataApi.ts
import { apiPaths, mamutilsApi } from '@services';
import {
    transformCollectionMetadata,
    transformOverrideHistoryResponse,
    transformSaveOverrideResponse,
} from '../utils/mappers';
import {
    GetCollectionMetadataResponse,
    GetCollectionMetadataArgs,
    GetOverrideHistoryArgs,
    GetOverrideHistoryResponse,
    SaveCollectionOverrideArgs,
    SaveCollectionOverrideResponse,
} from '../types';

const enhancedApi = mamutilsApi.enhanceEndpoints({
    addTagTypes: ['CollectionMetadata', 'OverrideHistory'],
});

const extendedApi = enhancedApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollectionMetadata: builder.query<
            GetCollectionMetadataResponse,
            GetCollectionMetadataArgs
        >({
            query: ({ proscopeId, nocache }) => ({
                method: 'GET',
                url: apiPaths.metadata.getCollectionMetadata(proscopeId),
                params: { nocache },
            }),
            transformResponse: transformCollectionMetadata,
            providesTags: () => [{ type: 'CollectionMetadata', id: 'LIST' }],
        }),

        getOverrideHistory: builder.query<
            GetOverrideHistoryResponse,
            GetOverrideHistoryArgs
        >({
            query: ({ proscopeId }) => ({
                method: 'GET',
                url: apiPaths.metadata.getOverrideHistory(proscopeId),
            }),
            transformResponse: transformOverrideHistoryResponse,
            providesTags: (_result, _error, arg) => [
                { type: 'OverrideHistory', id: arg.proscopeId },
            ],
        }),

        saveCollectionOverrides: builder.mutation<
            SaveCollectionOverrideResponse,
            SaveCollectionOverrideArgs
        >({
            query: ({ proscopeId, overrides, userId }) => ({
                method: 'PATCH',
                url: apiPaths.metadata.saveOverride(proscopeId),
                body: overrides,
                headers: {
                    'x-user-id': userId,
                },
            }),
            transformResponse: transformSaveOverrideResponse,
            invalidatesTags: (_result, _error, arg) => [
                { type: 'CollectionMetadata', id: arg.proscopeId },
                { type: 'CollectionMetadata', id: 'LIST' },
                { type: 'OverrideHistory', id: arg.proscopeId },
            ],
        }),
    }),
});

export const {
    useGetCollectionMetadataQuery,
    useGetOverrideHistoryQuery,
    useSaveCollectionOverridesMutation,
} = extendedApi;

export default extendedApi.endpoints;
